import { render, staticRenderFns } from "./UiIcon.vue?vue&type=template&id=a46a58b8&scoped=true"
import script from "./UiIcon.vue?vue&type=script&lang=js"
export * from "./UiIcon.vue?vue&type=script&lang=js"
import style0 from "./UiIcon.vue?vue&type=style&index=0&id=a46a58b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46a58b8",
  null
  
)

export default component.exports